import { ActiveContractFilter, ApplicationModel } from '../../../generated/ApiClient';

export const applyActiveContractFilter = (
  contracts: ApplicationModel[],
  filter: ActiveContractFilter
): ApplicationModel[] => {
  switch (filter) {
    case ActiveContractFilter.ExpireInLessThan90Days:
      return contracts.filter((x) => x.expireInLessThan90Days);
    case ActiveContractFilter.ExpireInLessThan180Days:
      return contracts.filter((x) => x.expireInLessThan180Days && !x.expireInLessThan90Days);
    case ActiveContractFilter.Settled:
      return contracts.filter((x) => x.settled);
    case ActiveContractFilter.Recently:
      return contracts.filter((x) => x.recently);
    case ActiveContractFilter.All:
    default:
      return contracts;
  }
};
